import { render, staticRenderFns } from "./operationDetail.vue?vue&type=template&id=11995cf6&scoped=true&"
import script from "./operationDetail.vue?vue&type=script&lang=js&"
export * from "./operationDetail.vue?vue&type=script&lang=js&"
import style0 from "./operationDetail.vue?vue&type=style&index=0&id=11995cf6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11995cf6",
  null
  
)

export default component.exports